function uuid(template) {
  return (template || 'xxxxxxxxxxxxxxxx').replace(/[x]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function isRealNum(val) {
  // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，

  if (val === '' || val == null) {
    return false;
  }

  if (typeof val === 'string' && val.length) return false 

  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(val)) {
    // 对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
    // 所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
    return true;
  }
  return false;
}

export default function (res) {
  // const res = repsoneData.data[0].labeling_results;
  const point_dict = res.point_dict;
  const graphic_list = res.graphic_list;

  const newkeys = {};
  const newDicts = {};

  Object.keys(point_dict).forEach((key) => {
    if (isRealNum(key)) {
      const newKey = uuid();
      newkeys[key] = newKey;
      newDicts[newKey] = point_dict[key];
      newDicts[newKey].uuid = newKey;
    } else {
      newDicts[key] = point_dict[key];
    }
  });

  // console.log(newkeys);
  // console.log(newDicts);
  graphic_list.forEach((item) => {
    const graphicId = item.graphic_id;
    if (isRealNum(graphicId)) {
      let newKey = newkeys[graphicId];
      if (!newKey) {
        newKey = uuid();
        newkeys[graphicId] = newKey;
      }
      item.graphic_id = newKey;
    }
  });

  // console.log(graphic_list);
  graphic_list.forEach((item) => {
    if (item.graphic_data.some(d => isRealNum(d))) {
      item.graphic_data.forEach((g, i) => {
        let newKey = newkeys[g];
        if (!newKey) {
          newKey = uuid();
          newkeys[g] = newKey;
        }
        if (isRealNum(g)) {
          item.graphic_data.splice(i, 1, newKey);
        }
      });
    }
  });

  res.point_dict = newDicts;
  res.graphic_list = graphic_list;

  return res;
}
